import { RPC_MAX_BASE64_DECODED_BYTES } from "../../../../backend/src/shared/mediaLimits";

export const RECORD_PHOTO_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";

export async function readRecordPhoto(file: File): Promise<{ base64Data: string; mimeType: string }> {
  if (!RECORD_PHOTO_ACCEPT.split(",").includes(file.type)) throw new Error("Choose a JPEG, PNG, WebP, or GIF photo.");
  if (!file.size || file.size > RPC_MAX_BASE64_DECODED_BYTES) throw new Error("Photos must be between 1 byte and 8 MB.");
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = "";
  for (let at = 0; at < bytes.length; at += 0x8000) binary += String.fromCharCode(...bytes.subarray(at, at + 0x8000));
  return { base64Data: btoa(binary), mimeType: file.type };
}
